import React, { useState } from 'react';
import { Grid, Icon, Form, Label } from 'semantic-ui-react';
import { ButtonLink, STATUS_TYPES, VALIDATORS } from 'dyl-components';

import { Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';
import PHONE_TYPE_OPTIONS from 'shared/constants/PHONE_TYPE_OPTIONS';
import './RecordPhonesForm.scss';
import { PhoneUtil } from 'utils';

const RecordPhonesForm = ({
    phones,
    control,
    onRemove,

    updateMain,

    checkDuplicates,
    setError,
    trigger,
    contact_id,
    allowNoPhones,

    fieldNamePrefix = '',
    isOfficeView,
    unknownNumber,
    existingContactMode,
    isForContact = false
}) => {
    const [focusedPhones, setFocusedPhones] = useState([]);
    
    const addFocus = (type) => {
        setFocusedPhones([...focusedPhones, type]);
    };
    const removeFocus = (type) => {
        setFocusedPhones(focusedPhones.filter(phone => phone !== type));
    }
    const isFocused = (type) => {
        return focusedPhones.includes(type);
    }
    const handleOnChangeForPhone = async (phone, onChange, name, value) =>{
        console.log("|+|phone", phone)
        if (phone.value !== unknownNumber) {
            await onChange({ target: { name, value } });
            if ((value !== '' && (await VALIDATORS.PHONE_NUMBER().isValid(value)))) {
                if (!existingContactMode || (existingContactMode && value !== phone.value)) {
                    const duplicatePhones = await checkDuplicates({ phones: [value] });
                    const possibleDuplicate = duplicatePhones?.filter((ele)=>{
                        return isForContact ? ele.contact_type === 'person' :  ele.contact_type === 'account'
                    })[0]?.contact_id
                    const hasNoDuplicates = possibleDuplicate === undefined || Number(possibleDuplicate) === Number(contact_id);
                    if (!hasNoDuplicates) {
                        await setError(name, {
                            type: 'unique_phone',
                            message: <Label color='red'>Phone matches an <Link className='RecordPhonesForm__matchLink' target={"_blank"} to={`/${isForContact ? 'contact' : 'account'}/${possibleDuplicate}`}>existing record</Link></Label>
                        })
                    }
                }
            }
        }
    }
    return (
        <Grid className='RecordInfo' columns='equal'>
            {phones.map((phone, index) => (
                <Controller
                    key={phone.id}
                    name={`${fieldNamePrefix}phones[${index}].value`}
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) => [
                        <Grid.Row columns='equal' verticalAlign='middle'>
                            <Grid.Column>
                                <Controller
                                    name={`${fieldNamePrefix}phones[${index}].type`}
                                    control={control}
                                    defaultValue={phone.type}
                                    render={({ field: { name, value, onChange } }) => {
                                        return (
                                            <Form.Dropdown
                                                selection
                                                name={name}
                                                value={value}
                                                onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                                placeholder='Type'
                                                options={PHONE_TYPE_OPTIONS.getOptions()}
                                                selectOnBlur={false}
                                                {...(isOfficeView && phone.value === unknownNumber ? { className: "RecordPhonesForm__typeField" } : {})}
                                            />
                                        )
                                    }}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Form.Input
                                    name={name}
                                    placeholder='Enter phone'
                                    error={Boolean(error?.message)}
                                    value={PhoneUtil.formatDisplayedValue(isFocused(name), value)}
                                    onFocus={() => {
                                        addFocus(name)
                                    }}
                                    onChange={async (_, { value }) => {
                                        await handleOnChangeForPhone(phone, onChange, name, value)
                                    }} 
                                    onPaste={(e) => (
                                        PhoneUtil.handlePhonePaste(e, async ({ target: { value:targetValue } }) => {
                                            await handleOnChangeForPhone(phone, onChange, name, targetValue);
                                        }, name)
                                    )}
                                    onBlur={async () => {
                                        PhoneUtil.handlePhoneBlur(value, async ({ target: { name, value } }) => {
                                            await handleOnChangeForPhone(phone, onChange, name, value);
                                        }, name, removeFocus);
                                    }}
                                    {...(isOfficeView && phone.value === unknownNumber ? { className: "RecordPhonesForm__typeField" } : {})}
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <div>
                                    <Controller
                                        name={`${fieldNamePrefix}phones[${index}].main`}
                                        control={control}
                                        render={({ field: { name, value, onChange } }) => (
                                            <Form.Radio
                                                name={name}
                                                checked={value}
                                                onChange={(_, { checked: value }) => {
                                                    updateMain(() => {
                                                        onChange({ target: { name, value } });
                                                    });
                                                }}
                                                label='Main'
                                            />
                                        )}
                                    />
                                </div>
                                {(allowNoPhones || phones.length > 1) && (
                                    <Form.Field>
                                        <ButtonLink style={{ marginLeft: '-0.5em' }} size='small' status={STATUS_TYPES.ERROR} onClick={() => { onRemove(index); }}>
                                            <Icon className='fas fa-trash-can' /> Delete
                                        </ButtonLink>
                                    </Form.Field>
                                )}
                            </Grid.Column>
                        </Grid.Row>,
                        <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Form.Field
                                    control={'div'}
                                    error={error && error.message}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    ]}
                />
            ))}
        </Grid>
    )
};

export default RecordPhonesForm;
